import React from "react";
import { Link, graphql } from "gatsby";
import Image from "gatsby-image";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { rhythm, scale } from "../utils/typography";
import "./blog-post.css";

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.markdownRemark;
  const siteTitle = data.site.siteMetadata.title;
  const { previous, next } = pageContext;

  const imagesFrontmatter = post.frontmatter.images
    ? post.frontmatter.images
    : [post.frontmatter.image];

  const images = data.allImageSharp.edges.filter(
    (edge) => imagesFrontmatter.indexOf(edge.node.fluid.originalName) >= 0
  );

  let imageClassName = "image-blog";
  if (images[0].node.fluid.aspectRatio == 1) {
    imageClassName = "image-blog";
  } else if (images[0].node.fluid.aspectRatio > 1.0) {
    imageClassName = "image-blog-wide";
  } else if (images[0].node.fluid.aspectRatio < 1.0) {
    imageClassName = "image-blog-tall";
  }

  return (
    <Layout location={location} title={siteTitle}>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
      />
      <article>
        <header>
          <h1
            style={{
              marginTop: rhythm(1),
              marginBottom: 0,
              marginLeft: `5%`,
            }}
          >
            {post.frontmatter.title}
          </h1>
        </header>
        <div style={{ marginLeft: `5%` }}>
          {post.frontmatter.tags.map((tag) => {
            return (
              <Link
                className="bookitem-tag"
                to={`/`}
                key={tag}
              >{`#${tag}`}</Link>
            );
          })}
        </div>
        <br />
        <br />
        <center>
          {images.map((img) => {
            return (
              <Image
                fluid={img.node.fluid}
                className={imageClassName}
                key={Math.random()}
              />
            );
          })}
        </center>
        <section
          style={{ marginLeft: `5%` }}
          dangerouslySetInnerHTML={{ __html: post.html }}
        />

        <hr
          style={{
            marginBottom: rhythm(1),
          }}
        />
      </article>

      <nav>
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
            marginLeft: `5%`,
            marginRight: `5%`,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.frontmatter.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.frontmatter.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </Layout>
  );
};

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      fields {
        slug
      }
      frontmatter {
        title
        slug
        image
        images
        tags
        date(formatString: "MMMM DD, YYYY")
        description
      }
    }
    allImageSharp {
      edges {
        node {
          fluid {
            base64
            tracedSVG
            aspectRatio
            srcWebp
            srcSetWebp
            originalName
          }
        }
      }
    }
  }
`;
